import React from "react";
import { Form, Button } from "react-bootstrap";
import * as Yup from "yup";
import { FormikHelpers, useFormik } from "formik";
import CustomModal from "../../../components/customModal/CustomModal";

interface MarkProcessedModalProps {
  onSave: (reason: string, closePOLine: boolean) => void;
  onClose: () => void;
}

const MarkProcessedModal: React.FC<MarkProcessedModalProps> = ({
  onSave,
  onClose,
}) => {
  const { handleChange, values, handleSubmit, touched, errors, setFieldValue } =
    useFormik({
      initialValues: {
        reason: "",
        closePOLine: true,
      },
      validationSchema: Yup.object({
        reason: Yup.string().required("Reason is Required"),
        closePOLine: Yup.boolean().required("Close PO Line is Required"),
      }),
      onSubmit: async (
        values: any,
        { setSubmitting }: FormikHelpers<any>
      ) => {
        try {
          onSave(values.reason, values.closePOLine);
        } catch (err: any) {}
        setSubmitting(false);
      },
    });

  return (
    <CustomModal
      title="Provide Reason"
      content={
        <div className="modal--content--wrapper">
          <div className="modal--inputbox">
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Reason</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter Reason"
                  id="reason"
                  name="reason"
                  value={values.reason}
                  onChange={handleChange}
                  isInvalid={touched.reason && !!errors.reason}
                />
                {touched.reason && errors.reason ? (
                  <Form.Control.Feedback type="invalid">
                    {errors.reason}
                  </Form.Control.Feedback>
                ) : null}
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  id="closePOLine"
                  name="closePOLine"
                  label="Close PO Line?"
                  checked={values.closePOLine}
                  onChange={(e) =>
                    setFieldValue("closePOLine", e.target.checked)
                  }
                  isInvalid={touched.closePOLine && !!errors.closePOLine}
                />
                {touched.closePOLine && errors.closePOLine ? (
                  <Form.Control.Feedback type="invalid">
                    {errors.closePOLine as string}
                  </Form.Control.Feedback>
                ) : null}
              </Form.Group>
              <Form.Group className="full-width text-end">
                <Button
                  onClick={onClose}
                  style={{ marginRight: "10px" }}
                  variant="outline-primary"
                >
                  Cancel
                </Button>
                <Button type="submit" variant="primary">
                  Save
                </Button>
              </Form.Group>
            </Form>
          </div>
        </div>
      }
      onClose={onClose}
    />
  );
};

export default MarkProcessedModal;
